import React from "react";
import { SCENARIO } from "../scenario/torbridge.js";

export function LayerSelector({
  selectedId,
  onSelect
}: {
  selectedId: string;
  onSelect: (id: string) => void;
}) {
  return (
    <div className="layer-selector" role="tablist" aria-label="Trust layers">
      {SCENARIO.layers.map((layer) => {
        const active = layer.id === selectedId;
        const violation = layer.id.includes("!");
        return (
          <button
            key={layer.id}
            role="tab"
            aria-selected={active}
            className={
              "layer-tab" +
              (active ? " layer-tab-active" : "") +
              (violation ? " layer-tab-violation" : "")
            }
            onClick={() => onSelect(layer.id)}
          >
            <span className="layer-tab-badge">{layer.badge}</span>
            <span className="layer-tab-title">{layer.title}</span>
          </button>
        );
      })}
    </div>
  );
}
